<template>
  <div>
    <Form :label-width="100" inline>
      <FormItem label="投诉单位名称" required>
        <Input style="width:600px;" v-model="complaintData.complainCompany"></Input>
      </FormItem>
      <FormItem label="投诉时间" required>
        <!-- <Input style="width:200px;"></Input> -->
        <DatePicker type="date" placeholder="选择时间" style="width: 200px" @on-change="receiveTimeChange" v-model="complaintData.complainTime"></DatePicker>
      </FormItem>
      <FormItem label="答复时间">
        <!-- <Input style="width:200px;"></Input> -->
        <DatePicker type="date" placeholder="选择时间" style="width: 200px" @on-change="responseTimeChange" v-model="complaintData.responseTime"></DatePicker>
      </FormItem>
      <FormItem label="回复文号">
        <Input style="width:200px;" v-model="complaintData.replyNumber"></Input>
      </FormItem>
      <!-- <FormItem label="收到书面形式">
        <Input style="width:200px;" v-model="questionData.written"></Input>
      </FormItem> -->
      <FormItem label="投诉阶段">
        <Input style="width:200px;" v-model="complaintData.complainStage"></Input>
      </FormItem>
      
      <div>
        <FormItem label="是否有效">
          <Select style="width:80px;" v-model="complaintData.isEnabled">
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        <FormItem label="是否提交报告">
          <Select style="width:80px;" v-model="complaintData.isSubmit">
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
      </div>
      <div>
        <FormItem label="电子文件">
          <Select style="width:80px;" v-model="complaintData.electronicFiles">
            <Option value="有">有</Option>
            <Option value="无">无</Option>
          </Select>
        </FormItem>
        <FormItem label="纸质原件">
          <Select style="width:80px;" v-model="complaintData.original">
            <Option value="有">有</Option>
            <Option value="无">无</Option>
          </Select>
        </FormItem>
        <FormItem label="处理结果">
          <Input style="width:200px;" v-model="complaintData.results"></Input>
        </FormItem>
      </div>
      <FormItem label="投诉要点描述">
        <Input type="textarea" :autosize="true" style="width:600px;" v-model="complaintData.describe"></Input>
      </FormItem>
      <FormItem label="投诉原因及分析">
        <Input style="width:600px;" v-model="complaintData.reason"></Input>
      </FormItem>
      <FormItem label="改进措施">
        <Input style="width:600px;" v-model="complaintData.measure"></Input>
      </FormItem>
      <FormItem label="关联项目" required>
        <Input style="width:200px;margin-right:5px;" v-model="complaintData.projectNum"></Input>
        <Button type="primary" size="small" @click="projectChoose">选择</Button>
      </FormItem>
    </Form>
    <!-- 项目关联选择 -->
    <Modal v-model="projectChooseVisible" title="关联选择" :transfer="false" width="800">
      <project-choose @endImport="importProject"></project-choose>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ProjectChoose from '@/components/projectChoose'

export default {
  name: 'questionForm',
  components: {
    ProjectChoose
  },
  props: {
    selectRegister: {
      type: Object
    }
  },
  data() {
    return {
      complaintData: {
        id: '',
        projectId: '',
        complainCompany: '',
        complainTime: '',
        describe: '',
        complainStage: '',
        followUp: '',
        projectManager: '',
        customer: '',
        responseTime: '',
        replyNumber: '',
        reason: '',
        results: '',
        measure: '',
        isEnabled: '',
        isSubmit: '',
        original: '',
        electronicFiles: '',
        projectNum: ''
      },
      projectChooseVisible: false
    }
  },
  methods: {
    projectChoose() {
      this.projectChooseVisible = true
    },
    importProject(project) {
      this.complaintData.projectId = project.id
      this.complaintData.projectNum = project.projectFull
      this.projectChooseVisible = false
    },
    getResult() {
      return this.complaintData
    },
    receiveTimeChange(time) {
      this.complaintData.complainTime = time
    },
    responseTimeChange(time) {
      this.complaintData.responseTime = time
    },
    clearRegister() {
      this.complaintData = {
        id: '',
        projectId: '',
        complainCompany: '',
        complainTime: '',
        describe: '',
        complainStage: '',
        followUp: '',
        projectManager: '',
        customer: '',
        responseTime: '',
        replyNumber: '',
        reason: '',
        results: '',
        measure: '',
        isEnabled: '',
        isSubmit: '',
        original: '',
        electronicFiles: '',
        projectNum: ''
      }
    }
  },
  watch: {
    selectRegister(register) {
      if (register) {
        this.complaintData = register
        this.complaintData.projectNum = register.clProject.projectFull
      }
    }
  }
}
</script>
